import { InternalElement } from "../lib/internal-element.js";
import { css, html } from "lit";
import { property, state, customElement } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let ToggleGroup = class extends InternalElement {
  constructor() {
    super(...arguments);
    this.selectedIndex = 0;
  }
  connectedCallback() {
    var _a;
    if (this.value) {
      this.selectedIndex = ((_a = this.options) == null ? void 0 : _a.map((o) => o.value).indexOf(this.value)) || 0;
    }
    super.connectedCallback();
  }
  updateSelectedIndex(i) {
    var _a;
    this.selectedIndex = i;
    this.dispatchEvent(new CustomEvent("value-change", {
      detail: (_a = this.options[i]) == null ? void 0 : _a.value
    }));
  }
  render() {
    var _a;
    return html`
      <section id="toggle-group">
        ${(_a = this.options) == null ? void 0 : _a.map((o, i) => html`
          <button @click=${() => this.updateSelectedIndex(i)} class=${classMap({ "selected": this.selectedIndex == i })}>${o.label}</button>
        `)}
      </section>
    `;
  }
};
ToggleGroup.styles = css`
    /* PROMOTIONAL HEADER STYLES */

    #toggle-group {
      display: inline-flex;
      width: 100%;
      margin-bottom: 10px;
      align-items: center;
    }

    #toggle-group button {
      padding: 5px;
      background-color: var(--default-vi-bg-color);
      flex: 1;
      outline: 0;
      text-align: center;
      border: 1px solid var(--default-vi-border-color);
      position: relative;
      font-family: var(--default-vi-font-family);
      color: rgba(0, 0, 0, 0.7);
      cursor: pointer;
      box-sizing: border-box;
      margin: -1px -1px 0 0px;
      white-space: nowrap;
    }

    #toggle-group button:not(:last-child) {
      border-right: none; /* Prevent double borders */
    }

    #toggle-group button:first-child {
      border-top-left-radius: var(--default-vi-border-radius);
      border-bottom-left-radius: var(--default-vi-border-radius);
    }

    #toggle-group button:last-child {
      border-top-right-radius: var(--default-vi-border-radius);
      border-bottom-right-radius: var(--default-vi-border-radius);
    }

    #toggle-group button.selected {
      background-color: var(--default-vi-primary-contrast-color);
      color: var(--default-vi-primary-color);
      border: 1px solid var(--default-vi-primary-color);
      font-weight: bold;
      border-radius: var(--default-vi-border-radius);
      padding: 8px 5px;
      z-index: 9;
    }
  `;
__decorateClass([
  property({ attribute: false })
], ToggleGroup.prototype, "options", 2);
__decorateClass([
  property()
], ToggleGroup.prototype, "value", 2);
__decorateClass([
  state()
], ToggleGroup.prototype, "selectedIndex", 2);
ToggleGroup = __decorateClass([
  customElement("toggle-group")
], ToggleGroup);
export {
  ToggleGroup
};
